module.exports = __webpack_public_path__ + "static/media/logo_blue.f9c431e5.png";